/**
 * remove focus funtion for button, chip and other clickable elements
 * while RMWC buttons maintain a highlighted state after being clicked, MUI buttons revert to their original color.
 */

import type {MouseEventHandler, RefObject} from 'react';

export function removeFocus(
  ele: RefObject<HTMLElement | null>,
  onClick?: MouseEventHandler<HTMLElement>,
  event?: React.MouseEvent<HTMLElement>,
) {
  if (onClick && event) {
    onClick(event);
  }

  const targetElement = ele.current?.children[0] as HTMLElement | undefined;

  if (!targetElement) return;

  const cleanUpFocus = (ev: Event) => {
    targetElement.blur();
  };

  targetElement.addEventListener('animationend', cleanUpFocus, {once: true});
  targetElement.addEventListener('transitionend', cleanUpFocus, {once: true});
}
